/**
 * @file    WorkerLauncherContent.jsx - Renders a description of the worker for
 *          the smith-rs brand.
 *
 * @author  Kirill Kirnichansky <kirill@distributive.network>
 * @date    Nov. 2022
 */

export const WorkerLauncherContent = () => {
  return (
    <div id="smith_rs_workerLauncherContent">
      <h2>
        Welcome to the DCP platform where users like you share 
        their computers' resources with researchers!
      </h2>
      <p>
        DCP will connect you to ongoing research projects in need of computing power. As DCP calculations
        are executed, Distributive Compute Credits will accumulate in your account. To contribute computing
        power to the platform, please keep this tab open.
      </p>
      <p>
        Despite relying on electricity and computing resources, DCP still has several important net environmental 
        benefits. By sharing your computer's resources, you can contribute to the environment in three ways, by:
      </p>
      <ol>
        <li>Supporting scientific research on topics like climate change prediction and simulation.</li>
        <li>Helping to reduce the need for highly polluting and energy-intensive datacenters to power complex scientific research.</li>
        <li>Donating any money you generate through sharing your computer's resources to an environmental cause.</li>
      </ol>
      <p>
        The more you share your computer's resources through DCP, the more you will contribute to environmental sustainability.
      </p>
      <p>
        To start executing calculations, <span className="bolded">click on Start Contributing.</span>
      </p>
    </div>
  )
}
